/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const selectors = {
    sizePopup: '.size-popup',
    searchInput: '.size-chart-search-input',
    toggleBullet: '.size-chart__toggler-bullet',
    toggleRadio: '[name="size-chart-toggler"]',
    sizeChart: '.size-table-wrapper',
    videoTag: '.video__player video',
    videoPlayBtn: '.video-play_btn'
  }

  const sizePopup = document.querySelector(selectors.sizePopup);
  if(!sizePopup) return;
  const toggleBullet = sizePopup.querySelector(selectors.toggleBullet);
  const toggleRadios = sizePopup.querySelectorAll(selectors.toggleRadio);
  const searchInputs = sizePopup.querySelectorAll(selectors.searchInput);
  const sizeCharts = sizePopup.querySelectorAll(selectors.sizeChart);

  toggleRadios.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      const value = e.target.value;
      sizeCharts.forEach(sizeChart => {
        if(sizeChart.dataset.type === value) {
          sizeChart.classList.add('active');
        } else {
          if (!sizeChart.classList.contains('product-size__wrapper')) {
            sizeChart.classList.remove('active');
          }
        }
      });
    });
  });

  toggleBullet.addEventListener('click', (e) => {
    e.preventDefault();
    const radio = sizePopup.querySelector(`${selectors.toggleRadio}:not(:checked)`);
    radio.checked = true;
    radio.dispatchEvent(new Event('change'));
  })

  searchInputs.forEach(input => {
    input.addEventListener('keyup', (e) => {
      searchTable();
    });
  });

  function searchTable() {
    searchInputs.forEach((searchInput, index) => {
      const query = Number(searchInput.value.trim());
      sizeCharts.forEach(sizeChart => {
        sizeChart.querySelectorAll(`td:nth-child(${index+3})`).forEach(td => {
          const text = td.textContent.trim().replace('"','');
          const array = text.split(' - ');
          const options = [];
          for(var i=array[0]; i<=array[1]; i++) {
            options.push(Number(i));
          }
          if(options.includes(query)) td.classList.add('active');
          else td.classList.remove('active');
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".fbt-slider"); // 你的滑块容器 class
    const thumb = document.querySelector(".scroll-thumb");
    const btnLeft = document.querySelector(".scroll-left");
    const btnRight = document.querySelector(".scroll-right");

    if (!slider || !thumb) return;

    const getCardWidth = () => {
      const card = slider.querySelector(".product-item");
      if (!card) return 0;
      const style = getComputedStyle(card);
      const width = card.offsetWidth + parseFloat(style.marginRight || 0);
      return width;
    };

    const updateThumb = () => {
      const scrollRatio = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
      const thumbWidth = slider.clientWidth / slider.scrollWidth * 100;
      thumb.style.width = thumbWidth + "%";
      thumb.style.left = scrollRatio * (100 - thumbWidth) + "%";
    };

    slider.addEventListener("scroll", updateThumb);
    updateThumb();

    btnLeft.addEventListener("click", () => {
      slider.scrollBy({ left: -getCardWidth(), behavior: "smooth" });
    });

    btnRight.addEventListener("click", () => {
      slider.scrollBy({ left: getCardWidth(), behavior: "smooth" });
    });
  });

  document.addEventListener("DOMContentLoaded", () => {
    const tryInit = () => {
      const slider = document.querySelector("#product-recommendations");
      if (!slider) return false;
      const parent = document.querySelector('#product-recommendations').parentNode;
      const thumb = parent.querySelector(".scroll-thumb");
      const btnLeft = parent.querySelector(".scroll-left");
      const btnRight = parent.querySelector(".scroll-right");

      if (!slider || !thumb) return;

      const getCardWidth = () => {
        const card = slider.querySelector(".product-item");
        if (!card) return 0;
        const style = getComputedStyle(card);
        const width = card.offsetWidth + parseFloat(style.marginRight || 0);
        return width;
      };

      const updateThumb = () => {
        const scrollRatio = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
        const thumbWidth = slider.clientWidth / slider.scrollWidth * 100;
        thumb.style.width = thumbWidth + "%";
        thumb.style.left = scrollRatio * (100 - thumbWidth) + "%";
      };

      slider.addEventListener("scroll", updateThumb);
      updateThumb();

      btnLeft.addEventListener("click", () => {
        slider.scrollBy({ left: -getCardWidth(), behavior: "smooth" });
      });

      btnRight.addEventListener("click", () => {
        slider.scrollBy({ left: getCardWidth(), behavior: "smooth" });
      });
      return true;
    };

    if (!tryInit()) {
      const observer = new MutationObserver(() => {
        if (tryInit()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();